module.exports = __webpack_public_path__ + "img/74.ebc61be1.jpg";